/**
 * The design shows three rows of two (six cards); 20 is requested so the page
 * surfaces more of the inventory, and so a later "load more" has stock without a
 * second round trip. Everything returned is rendered — this step has no
 * pagination control.
 */
export const OFFERINGS_PAGE_SIZE = 20;

/**
 * Deliberately short of `OFFERINGS_PAGE_SIZE`: the skeleton only has to fill the
 * screen while the query runs, and 20 placeholders would stretch the loading
 * state far past what the reader can see.
 */
export const SKELETON_CARD_COUNT = 12;

/** Two per row on desktop, one on mobile, per the design. */
export const GRID_COLUMNS = { base: 1, sm: 2 };

/** 8px gutter on mobile, 16px from `sm`, matching the design and the rails. */
export const GRID_SPACING_X = { base: '2', sm: '4' };

/**
 * Deliberately looser than the column gutter, per the design: 24px on mobile,
 * 36px from `sm`. The rows are what a reader scrolls past, so they get the room
 * the columns — which only have to separate two cards side by side — do not.
 */
export const GRID_SPACING_Y = { base: '6', sm: '9' };

/**
 * Mobile brings cards nearer the edge than the copy (8px vs. the container's
 * 24px) so the grid lines up with the page's rails, not the headings above it.
 * Desktop keeps the container's gutter.
 */
export const GRID_BLEED = { base: '-4', sm: '0' };

export const LOADING_LABEL = 'Loading ventures';
export const EMPTY_MESSAGE = 'No ventures match this sector yet.';
